import React from 'react';

const STEPS = [
  {
    icon: '🔍',
    title: 'Artikel finden',
    desc: 'Durchsuche gebrauchte Sportartikel von Vereinen in deiner Region',
  },
  {
    icon: '💬',
    title: 'Verkäufer kontaktieren',
    desc: 'Schreib dem Verkäufer direkt eine Nachricht über den Chat-Button auf der Produktseite',
  },
  {
    icon: '🤝',
    title: 'Treffen & Abholen',
    desc: 'Vereinbart einen Treffpunkt und holt den Artikel persönlich ab',
  },
  {
    icon: '📦',
    title: 'Versand auf Anfrage',
    desc: 'Manche Verkäufer verschicken auch – einfach per Chat nachfragen',
  },
];

const HowItWorks: React.FC = () => (
  <section data-testid="how-it-works" className="mt-10 mb-4 px-1">
    <h2 className="text-lg font-bold text-gray-800 mb-5 text-center">So funktioniert es</h2>
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {STEPS.map((step, i) => (
        <div key={i} className="flex md:flex-col items-start md:items-center gap-3 md:gap-2 bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
          <div className="flex-shrink-0 w-11 h-11 rounded-full bg-orange-100 flex items-center justify-center text-xl">
            {step.icon}
          </div>
          <div className="md:text-center">
            <p className="font-semibold text-gray-800 text-sm">{step.title}</p>
            <p className="text-gray-500 text-xs mt-0.5 leading-relaxed">{step.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
